/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ShareCopyType = {
    GUILD: 'GUILD',
    CHALLENGE: 'CHALLENGE',
    STANDARD: 'STANDARD',
    TOURNAMENT: 'TOURNAMENT',
    TOURNAMENT_TEAM: 'TOURNAMENT_TEAM',
    LEADERBOARD: 'LEADERBOARD',
    HUB: 'HUB',
    STREAK_MILESTONE: 'STREAK_MILESTONE',
    SEASON_TIER_UNLOCKED: 'SEASON_TIER_UNLOCKED',
    CLIP_SHARED: 'CLIP_SHARED'
} as const;
export type ShareCopyType = typeof ShareCopyType[keyof typeof ShareCopyType];


export function instanceOfShareCopyType(value: any): boolean {
    for (const key in ShareCopyType) {
        if (Object.prototype.hasOwnProperty.call(ShareCopyType, key)) {
            if (ShareCopyType[key as keyof typeof ShareCopyType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ShareCopyTypeFromJSON(json: any): ShareCopyType {
    return ShareCopyTypeFromJSONTyped(json, false);
}

export function ShareCopyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareCopyType {
    return json as ShareCopyType;
}

export function ShareCopyTypeToJSON(value?: ShareCopyType | null): any {
    return value as any;
}

export function ShareCopyTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ShareCopyType {
    return value as ShareCopyType;
}

